import React from 'react';
import ProjectsCTA from './ProjectsCTA';
import ProjectsGrid from './ProjectsGrid';
import ProjectsHero from './ProjectsHero';
import { projectsData } from '../../utils/projectsData';
import SEO from '../SEO/SEO';
import { BreadcrumbSchema } from '../SEO/StructuredData';

const ProjectsPageLayout: React.FC = () => {
  return (
    <main className="pt-[72px]">
      <SEO
        title="Projects"
        description="Review Cool & Care projects across CCTV surveillance, fire safety, HVAC, maintenance, and solar deployments in the Democratic Republic of the Congo."
        keywords="Cool and Care projects, CCTV projects DRC, fire safety installations, HVAC projects, solar deployments Kinshasa"
      />
      <BreadcrumbSchema items={[{ name: 'Projects', url: '/projects' }]} />
      <ProjectsHero />
      <ProjectsGrid items={projectsData} />
      <ProjectsCTA />
    </main>
  );
};

export default ProjectsPageLayout;
